// extracted by mini-css-extract-plugin
export default {"title":"AdvancePaymentDetails_title__yYTOb","total":"AdvancePaymentDetails_total__IA3e8","edit":"AdvancePaymentDetails_edit__ByAuZ"};